import Config from "./global/Config.js"
import $ from "jquery"
import { isMobileDevice } from "./utils/helper.js"
import Accessibility from "./utils/Accessibility.js"
import AOForms from "./utils/AOForms.js"
import AnchorLink from "./utils/AnchorLink.js"
import GeneralHelper from "./utils/GeneralHelper.js"
import "./utils/typo3-SpamProtectedEmails.js"

import DynamicModuleLoader from "./global/DynamicModuleLoader.js"
import DynamicExternalModuleLoader from "./global/DynamicExternalModuleLoader.js"

class Main {
	constructor() {
		this.setGlobalVars()
		this.setWebpackPublicPath()
		this._init()
	}

	_init() {
		$(document.body).removeClass("no-js")

		if (isMobileDevice()) {
			$(document.body).addClass("is-mobile")
		}

		// check if webp images ara supportet, if not show fallback (for IE11 and Safari)
		var webP = new Image()
		webP.onload = webP.onerror = () => {
			if (webP.height !== 2) {
				$(document)
					.find("img[data-srcfallback]")
					.each(function () {
						$(this).attr("src", $(this).attr("data-srcfallback"))
					})
			}
		}
		webP.src =
			"data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA"

		//some forms were lazy loaded, make sure that form component is loaded in this case
		$("body").on("bb-form-items-changed", () => {
			DynamicModuleLoader.load($("form").length, DynamicModuleLoader.modules.formComponent)
		})

		// set timeout for storybook
		if (isDev) {
			window.setTimeout(() => {
				this.dynamicLoad()
			}, 1250)
		} else {
			this.dynamicLoad()
		}
	}

	dynamicLoad() {
		DynamicModuleLoader.load($(".repeatable-container").length, DynamicModuleLoader.modules.formRepeatable)
		DynamicModuleLoader.load(Config.debug, DynamicModuleLoader.modules.versionDisplay)
		DynamicModuleLoader.load($("[data-lightbox]").length, DynamicModuleLoader.modules.lightboxComponent)
		DynamicModuleLoader.load($("form:not(.ao-form)").length, DynamicModuleLoader.modules.formComponent)
		DynamicModuleLoader.load(
			$("[data-repeatable-container][data-is-root]").length,
			DynamicModuleLoader.modules.formRepeatable,
		)
		DynamicModuleLoader.load(
			$(".bb-accordion").length,
			DynamicModuleLoader.modules.accordionComponent,
			(Component) => {
				document.querySelectorAll(".bb-accordion").forEach((item) => new Component(item))
			},
		)
		DynamicModuleLoader.load(
			$(".bb-back-to-top-button").length,
			DynamicModuleLoader.modules.backToTopButtonComponent,
		)
		DynamicModuleLoader.load($(".bb-breadcrumb").length, DynamicModuleLoader.modules.breadcrumbComponent)
		DynamicModuleLoader.load($(".bb-downloads").length, DynamicModuleLoader.modules.downloadsComponent)
		DynamicModuleLoader.load($(".bb-gallery").length, DynamicModuleLoader.modules.galleryComponent)
		DynamicModuleLoader.load($(".bb-header").length, DynamicModuleLoader.modules.headerComponent)
		DynamicModuleLoader.load($(".bb-hamburger").length, DynamicModuleLoader.modules.hamburgerComponent)
		DynamicModuleLoader.load($(".bb-logo-slider").length, DynamicModuleLoader.modules.logoSliderComponent)
		DynamicModuleLoader.load($(".bb-news-categories").length, DynamicModuleLoader.modules.newsCategoriesComponent)
		DynamicModuleLoader.load($(".bb-news-filter").length, DynamicModuleLoader.modules.newsFilterComponent)
		DynamicModuleLoader.load($(".bb-overlay").length, DynamicModuleLoader.modules.overlayComponent)
		DynamicModuleLoader.load($(".bb-search-overlay").length, DynamicModuleLoader.modules.searchOverlayComponent)
		DynamicModuleLoader.load(
			$(".bb-searchresult-filter").length,
			DynamicModuleLoader.modules.searchresultFilterComponent,
		)
		DynamicModuleLoader.load($(".bb-slider-container").length, DynamicModuleLoader.modules.sliderContainerComponent)
		DynamicModuleLoader.load($(".bb-tabs").length, DynamicModuleLoader.modules.tabsComponent)
		DynamicModuleLoader.load($(".bb-teaser-logo").length, DynamicModuleLoader.modules.teaserLogoComponent)
		DynamicModuleLoader.load($(".bb-video--youtube").length, DynamicModuleLoader.modules.videoYoutubeComponent)
		DynamicModuleLoader.load($(".bb-video--polyv").length, DynamicModuleLoader.modules.videoPolyvComponent)
		DynamicModuleLoader.load($(".bb-video-tabs").length, DynamicModuleLoader.modules.videoTabsComponent)

		Config?.module?.external?.forEach((item) => {
			DynamicExternalModuleLoader.load($(item.selector).length, item.js, item.css)
		})
	}

	/**
	 * set variable in window scope
	 */
	setGlobalVars() {
		window.$ = window.jQuery = $
	}

	/**
	 * Change webpacks publicPath on the fly
	 */
	setWebpackPublicPath() {
		if (Config.publicPath) {
			__webpack_public_path__ = Config.publicPath
		}
	}

	/**
	 * Google Maps Callback:
	 * initMap() from Maps2 Extension
	 * hide Controls
	 */
	initMap() {
		window.initMap()
		$("form.txMaps2Form").hide()
	}
}

$(() => {
	window.bbMain = new Main()
})

$(window).on("load", () => {
	window.setTimeout(() => {
		new Accessibility()
		new AnchorLink()
		new GeneralHelper()
		// loads always because there is no proper selector for ActOn Forms on the page
		new AOForms()
	}, 10)
})

if (window.location.hash) {
	window.scroll(0, 0)
}
